import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Calendar, MapPin, AlertTriangle, Eye } from "lucide-react";

const TWorkOrderCard = ({ repairInfo, reportingDate, onView }) => {

  const assetName = repairInfo?.assetName;
  const area = repairInfo?.area;
  const priority = repairInfo?.priority;

  const getPriorityColor = (priority) => {
    switch (priority?.toLowerCase()) {
      case "high":
        return "destructive";
      case "medium":
        return "default";
      case "low":
        return "secondary";
      default:
        return "outline";
    }
  };

  return (
    <Card 
      className="hover:shadow-xl hover:-translate-y-1.5 transition-all duration-300 border-zinc-200 cursor-pointer overflow-hidden group"
      onClick={onView}
    >
      <CardHeader className="pb-3 bg-zinc-50/50 group-hover:bg-white transition-colors duration-300">
        <CardTitle className="text-lg font-bold text-zinc-800 group-hover:text-zinc-900 transition-colors">
          {assetName}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4 pt-4">
        <div className="space-y-2">
          <div className="flex items-center gap-2 text-sm text-zinc-500 font-medium">
            <Calendar className="w-4 h-4 text-zinc-400 group-hover:text-[#305845] transition-colors" />
            <span>Reported: {reportingDate}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-zinc-500 font-medium">
            <MapPin className="w-4 h-4 text-zinc-400 group-hover:text-[#305845] transition-colors" />
            <span>{area}</span>
          </div>
        </div>
        
        <div className="flex items-center justify-between pt-2">
          <Badge
            variant={getPriorityColor(priority)}
            className="flex items-center gap-1.5 px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider shadow-sm"
          >
            <AlertTriangle className="w-3 h-3" />
            {priority}
          </Badge>
          <Button
            onClick={(e) => {
              e.stopPropagation();
              onView();
            }}
            size="sm"
            className="flex items-center gap-2 bg-[#305845] text-white hover:bg-[#305845]/90 border-none shadow-md hover:shadow-lg hover:scale-105 transition-all duration-300 px-4"
          >
            <Eye className="w-4 h-4" />
            View
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default TWorkOrderCard;
